var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sopAsPdfStorage)?_c('v-container',{staticClass:"pa-0",attrs:{"fill-height":""}},[_c('embed',{attrs:{"src":_vm.blobReference,"width":"100%","height":"100%","type":"application/pdf","data-test-embed-pdf":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }